import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';

import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import { Observable, Subscription } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AddSupplierComponent } from '../add-supplier/add-supplier.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class SupplierListComponent implements OnInit, OnDestroy, AfterViewInit {
  public loading: boolean = false;
  public suppliers: any = [];
  public totalSuppliers: number = 0;
  public currentPage: any;
  public currentSortProperty: string;
  public currentSortDirection: string;
  private _searchSubscription: Subscription;
  public addNewSupplier: boolean = false;
  public filter: any = {
    searchText: '',
    sorting: {
      field: "name",
      direction: "asc"
    },
    pagination: {
      page: 1,
      limit: 10
    }
  };

  constructor(
    public _supplierService: SupplierService,
    private _errorHandlerService: ErrorHandlerService,
    private cdRef: ChangeDetectorRef,
    public modal: ModalService,
    private _router: Router,
    public header: HeaderService) { }

  ngOnInit() {
    this._loadSuppliers(true);
  }

  ngAfterViewInit() {
    this._setupSearch();
  }

  /**
   * Refreshes data from api with sorting
   * @param property used to sort data
   * @param direction asc/desc
   */
  public sort(property: string, direction: string): void {
    this.filter.sorting.field = property;
    this.filter.sorting.direction = direction;
    this.currentSortProperty = property;
    this.currentSortDirection = direction;
    this.filter.searchText = (document.getElementById("input-search-supplier") as HTMLElement)['value'];
    this._loadSuppliers();
  }

  /**
   * Refreshes data from api of current page
   * @param pageNumber
   */
  public pageChange(pageNumber: number): void {
    this.filter.pagination.page = pageNumber;
    this.currentPage = pageNumber;
    this.filter.searchText = (document.getElementById("input-search-supplier") as HTMLElement)['value'];
    this._loadSuppliers();
  }

  public close(): void {
    this.addNewSupplier = false;
  }

  public openModal(type: String) {
    if (type === 'addSupplier') {
      this.modal.open(AddSupplierComponent);
    }
  }

  /**
   * Load suppliers with current sorting, pagination and search text
   */
  private _loadSuppliers(initialLoad: boolean = false): void {
    this.loading = true;
    this._supplierService.getFilteredSuppliers(this.filter).then((suppliers: any) => {
      this.suppliers = suppliers.data || [];
      this.totalSuppliers = suppliers.meta.total || 0;
      if (initialLoad) this._setTilesCount(this.totalSuppliers);
      this.loading = false;
    }).catch(err => {
      this._errorHandlerService.handleError(err, 'Error while filtering Suppliers!!');
      this.loading = false;
    })
  }

  /**
   * Host tiles cound data
   * @param suppliersCount
   */
  private _setTilesCount(suppliersCount: number = 0): void {
    this.header.metrics = [{ label: 'ALL', amount: suppliersCount }]
  }

  /**
   * Setup Supplier search
   * Observes the element with id "searchText"
   * Waits 500 milliseconds before it sends filter request to back end
   */
  private _setupSearch(): void {
    this._searchSubscription = Observable.fromEvent(document.getElementById('input-search-supplier'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      this.filter.searchText = searchText.trim();
      this._loadSuppliers();
    });
  };

  /**
   * Unsubscribe search subscription
   */
  ngOnDestroy(): void {
    this._searchSubscription.unsubscribe();
  }

  public showMassUpload: boolean = false;
  public btnOptions: any[] = [{ value: 'mass-upload', label: 'Mass Upload' }];

  /**
   * Perform actions based on button clicked
   * btn-add --> Open Add supplier button
   * show-options, mass-upload --> Set showMassUpload
   * @param $event { event.value } => btn-add/show-options/mass-upload
   */
  public optionClicked($event: any): void {
    if ($event.value === 'btn-add') {
      this.openModal('addSupplier');
    } else if ($event.value === 'show-options') {
      this.showMassUpload = true;
    } else if ($event.value === 'mass-upload') {
      this._router.navigateByUrl('suppliers/mass-upload');
    }
  }

  /**
   * Hide mass upload dropdown on click away from the button area
   */
  public clickingAway() {
    this.showMassUpload = false;
    this.cdRef.detectChanges();
  }
}
